import { render, staticRenderFns } from "./EventServicesCatalog.vue?vue&type=template&id=2ddd19b6"
import script from "./EventServicesCatalog.vue?vue&type=script&lang=js"
export * from "./EventServicesCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports